import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";

interface ModalHashTagProps {
  textButtonClose?: string;
  textButtonConfirm?: string;
  isLoading?: boolean;
  hashtags?: any;
  listHashtag?: any;
  numMaxHashtag?: number;
  onClose?: () => void;
  onConfirm?: (hashtags: []) => void;
}

const ModalHashTag = ({
  textButtonClose,
  textButtonConfirm,
  isLoading = false,
  hashtags,
  listHashtag = [],
  numMaxHashtag = 3,
  onClose,
  onConfirm,
}: ModalHashTagProps) => {
  const { t } = useTranslation();

  const [lstHashtagSelected, setLstHashtagSelected] = useState<any>([]);
  const [isShowMessage, setIsShowMessage] = useState<any>(false);

  useEffect(() => {
    if(hashtags?.length > 0) {
      setLstHashtagSelected(hashtags)
    }
  }, [hashtags])

  const handleCloseConfirmClick = () => {
    onClose && onClose();
  };

  const handleActionConfirm = (hashtags: any) => {
    onConfirm && onConfirm(hashtags);
  };

  const ItemHashTag = ({item} : any) => {
    if(!item) return;

    const handleChooseTag = (hashtag: string) => {
      setIsShowMessage(false);
      let dataHashtagSelected = [...lstHashtagSelected];
      const isActiveHashTag = dataHashtagSelected?.find((item: any) => item?.content === hashtag);

      if(isActiveHashTag) {
        setLstHashtagSelected(dataHashtagSelected?.filter((item) => item?.content !== hashtag))
      } else {
        if(dataHashtagSelected?.length > 2) {
          setIsShowMessage(true);
          return;  
        }
        
        const formatData = {
          content: hashtag,
          normal_text_color: item?.normal_text_color,
          active_text_color: item?.active_text_color,
          normal_background_color: item?.normal_background_color,
          active_background_color: item?.active_background_color
        }
  
        setLstHashtagSelected([
          ...dataHashtagSelected,
          formatData
        ])
      }
    }

    return item?.hashtags?.length > 0 && item?.hashtags?.map((hashtag: any, index: number) => {
      const isActiveHashTag = lstHashtagSelected?.find((item: any) => item?.content === hashtag);
      
      const style = {
        backgroundColor: isActiveHashTag ? item?.active_background_color : item?.normal_background_color, 
        borderColor: isActiveHashTag ? item?.active_background_color : item?.normal_background_color, 
        color: isActiveHashTag ? item?.active_text_color : item?.normal_text_color
      }

      return <span
        onClick={() => handleChooseTag(hashtag)}
        dangerouslySetInnerHTML={{ __html: hashtag }}
        key={index}
        className="hashtag-style"
        style={style}
      />
    })
  }

  const GroupHashTag = ({listHashtag} : any) => {
    if(listHashtag?.length < 0)  return;
    
    return (
      <div className="d-flex gap-1 flex-column" style={{flexWrap: 'wrap', minWidth: 280}}>
        {listHashtag?.map((item: any, index: number) => {
          return (
            <div className="mb-2" key={index}>
              <h5 style={({color: item?.name_color})}>{item?.name}</h5>
              <div>
                <ItemHashTag item={item}/>
              </div>
            </div>
          );
        })}
      </div>
    )
  }

  return (
    <React.Fragment>
      <Modal
        isOpen={true}
        centered={true}
        size="md"
        toggle={handleCloseConfirmClick}
        keyboard={true}
      >
        <ModalHeader toggle={isLoading ? () => { } : handleCloseConfirmClick}>
          {t("Hashtag")}
        </ModalHeader>
        <ModalBody className="">
          <div className="row g-4">
            <Col sm={12}>
              <div className="row g-3">
                <div className="mt-4">
                  
                  <GroupHashTag listHashtag={listHashtag} />
                  {
                    isShowMessage && (
                      <div className="text-danger mt-2">
                        {t('You can only select a maximum of 3 hashtags')}
                      </div>
                    )
                  }

                  <div className="hstack gap-2 justify-content-center mt-5">
                    <button
                      className={`btn btn-primary fs-14`}
                      type="button"
                      disabled={isLoading}
                      onClick={() => handleActionConfirm(lstHashtagSelected)}
                    >
                      {isLoading ? (
                        <Spinner size="sm" className="me-2"></Spinner>
                      ) : (
                        <i
                          className={`ri-login-circle-line align-bottom me-1`}
                        ></i>
                      )}
                      {textButtonConfirm ?? t("Button Save")}
                    </button>

                    <button
                      className="btn btn-soft-secondary fs-14"
                      type="button"
                      color="light"
                      onClick={handleCloseConfirmClick}
                      disabled={isLoading}
                    >
                      <i className="ri-indeterminate-circle-line align-bottom me-1"></i>
                      {textButtonClose ?? t("Button Close")}
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ModalHashTag;
